import * as React from 'react'

export const SandboxIcon = React.memo<JSX.IntrinsicElements['svg']>((props) => {
  return (
    <svg
      width="48"
      height="48"
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2 12C2 10.8954 2.89543 10 4 10H36C37.1046 10 38 10.8954 38 12V36C38 37.1046 37.1046 38 36 38H4C2.89543 38 2 37.1046 2 36V12Z"
        fill="#5BBBFC"
      />
      <path
        d="M22 22C22 20.8954 22.8954 20 24 20H44C45.1046 20 46 20.8954 46 22V40C46 41.1046 45.1046 42 44 42H24C22.8954 42 22 41.1046 22 40V22Z"
        fill="#DD7F57"
      />
      <path
        d="M38 20V36C38 37.1046 37.1046 38 36 38H22V22C22 20.8954 22.8954 20 24 20H38Z"
        fill="#FAF8F5"
      />
      <path
        d="M26.123 32.7838C25.9712 32.9715 25.9752 33.241 26.1326 33.4241L28.5105 36.1911C28.6904 36.4005 29.0061 36.4244 29.2156 36.2444L29.7844 35.7556C29.9938 35.5756 30.0177 35.2599 29.8377 35.0505L28.8275 33.875L33.5001 33.875C33.7763 33.875 34.0001 33.6511 34.0001 33.375V32.625C34.0001 32.3489 33.7763 32.125 33.5001 32.125L28.9066 32.125L29.8658 30.939C30.0395 30.7243 30.0062 30.4095 29.7915 30.2358L29.2084 29.7642C28.9937 29.5905 28.6789 29.6238 28.5052 29.8385L26.123 32.7838Z"
        fill="#4F2825"
      />
      <path
        d="M16.5 18.5C16.5 20.3919 15.3325 22.0111 13.6787 22.6764C17.291 23.4478 20 26.6575 20 30.5V33.1481C20 33.6186 19.6186 34 19.1481 34H4.85185C4.38139 34 4 33.6186 4 33.1481V30.5C4 26.6575 6.70897 23.4478 10.3213 22.6764C8.66746 22.0111 7.5 20.3919 7.5 18.5C7.5 16.0147 9.51472 14 12 14C14.4853 14 16.5 16.0147 16.5 18.5Z"
        fill="#001C64"
      />
      <path
        d="M33.8676 24.5759C34.025 24.759 34.029 25.0285 33.8771 25.2162L31.4949 28.1615C31.3213 28.3762 31.0064 28.4095 30.7917 28.2358L30.2086 27.7642C29.9939 27.5905 29.9606 27.2757 30.1343 27.061L31.0935 25.875L26.5 25.875C26.2239 25.875 26 25.6511 26 25.375L26 24.625C26 24.3489 26.2239 24.125 26.5 24.125L31.1726 24.125L30.1624 22.9495C29.9825 22.7401 30.0063 22.4244 30.2158 22.2444L30.7846 21.7556C30.994 21.5756 31.3097 21.5995 31.4897 21.8089L33.8676 24.5759Z"
        fill="#001C64"
      />
    </svg>
  )
})

SandboxIcon.displayName = 'SandboxIcon'
